import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO";
import { HeaderNav } from "../components/partials/HeaderNav";
import { NotificationBanner } from "../components/shared/warningNotification";
import { Footer } from "../components/partials/Footer";
import { Productsv2 } from "../components/shared/productsv2";
import { useSelector } from "react-redux";
import styled from "styled-components";

const StyledShopPage = styled.div`
    ${props => props.brand && `
        .shop-header {
            background: ${props.brand.colors.linearBackground} !important;
            padding-top: 13rem !important;
        }
    `}
`;

const ShopCategories = styled.div`
    ${props => props.brand && `
        button.active {
            background-color:  ${props.brand.colors.accountLabel} !important;
            border:  2px solid ${props.brand.colors.accountLabel} !important;
        }
    `}
`;

const ShopV2 = (props) => {
    const location = useLocation();

    const auth = JSON.parse(localStorage.getItem("profile"));
    const account = useSelector((state) => state.account);
    const { brand } = account;

    const [view, setView] = useState("list");
    const [isLoading, setIsLoading] = useState(false);
    const [category, setCategory] = useState("Pharmaceuticals");
    const [currentPage, setCurrentPage] = useState(1);
    
    // Function to set category and always reset to page 1
    const setCategoryPreservePage = (newCategory) => {
        // Update the category state
        setCategory(newCategory);
        
        // Get current URL parameters
        const params = new URLSearchParams(location.search);
        
        // Always set category and reset to page 1 for category changes
        params.set('category', newCategory);
        params.set('page', '1');
        
        // Replace current URL without reloading the page
        window.history.replaceState(
            {},
            '',
            `${location.pathname}?${params.toString()}`
        );
    };

    // Modified to set category directly instead of clicking buttons
    const selectedCategory = () => {
        const query = new URLSearchParams(props.location.search);
        const cat = query.get("category");
        
        if (cat && cat !== "") {
            // Set category directly instead of clicking buttons
            // This prevents unnecessary URL changes
            if (cat === "Favorites" && auth) {
                setCategory("Favorites");
            } else if (cat === "Pharmaceuticals") {
                setCategory("Pharmaceuticals");
            } else if (cat === "Animal Health" || cat === "animalhealth") {
                setCategory("Animal Health");
            } else if (cat === "Medical Supplies" || cat === "medicalsupplies") {
                setCategory("Medical Supplies");
            } else if (cat === "Specials" || cat === "specials") {
                setCategory("Specials");
            } else if (brand && brand.name === 'premierpharma' && 
                      (cat === "Premier's Choice" || cat === "premierschoice")) {
                setCategory("Premier's Choice");
            }
        } else {
            // Default to Pharmaceuticals if no category is specified
            setCategory("Pharmaceuticals");
        }
    };

    useEffect(() => {
        selectedCategory();
        // setIsLoading(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, brand]);

    useEffect(() => {
        selectedCategory();
        setIsLoading(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    // Update current page when URL changes
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const page = parseInt(params.get('page')) || 1;
        setCurrentPage(page);
    }, [location.search]);

    return (
        <>
            <SEO 
                title="Shop Pharmaceuticals | Premier Pharmaceuticals"
                description="Browse our extensive catalog of quality pharmaceutical products including pharmaceuticals, animal health, and medical supplies with fast, reliable shipping."
                keywords="pharmaceutical shop, buy medicine, healthcare products, pharmacy supplies, medical equipment, animal health, medical supplies"
                url="https://app.premierpharma.com/shop"
            />
            <HeaderNav />
            <StyledShopPage brand={brand} className="shop-page">
                <div className="shop-header container-fluid px-4">
                    {/* {category === "Smoking Cessation"?
                    <h2>Find a great collection of 
                    <em> Smoking Cessation</em> at Premier Pharma<br />
                    Enjoy low warehouse prices on 
                    <em> Smoking Cessation</em> products.</h2> :
                        category === "Favorites" ? <h1>Revisit your saved products</h1>
                            : category === "Specials" ? <h1>Find short-dated products <br /> for a low cost</h1>
                                : category === "Pharmaceuticals" ? <h1>Shop all pharmaceuticals <br /> at a low cost</h1>
                                    : category === "Animal Health" ? <h1>Shop animal health products <br /> at a low cost</h1>
                                        : category === "Medical Supplies" ? <h1>Shop medical/surgical products <br /> at a low cost</h1>
                                            : <h1> </h1>
                    } */}
                    {category === "Premier's Choice"?
                    <h1>Shop Premier's {new Date().getFullYear()} Top 25 Best Sellers.</h1> :
                        category === "Favorites" ? <h1>Revisit your saved products</h1>
                            : category === "Specials" ? <h1>Find short-dated products <br /> for a low cost</h1>
                                : category === "Pharmaceuticals" ? <h1>Shop all pharmaceuticals <br /> at a low cost</h1>
                                    : category === "Animal Health" ? <h1>Shop animal health products <br /> at a low cost</h1>
                                        : category === "Medical Supplies" ? <h1>Shop medical/surgical products <br /> at a low cost</h1>
                                            : <h1> </h1>
                    }
                    {/* {
                    category === "Favorites" ? <h1>Revisit your saved products</h1>
                    : category === "Specials" ? <h1>Find short-dated products <br /> for a low cost</h1>
                    : category === "Pharmaceuticals" ? <h1>Shop all pharmaceuticals <br /> at a low cost</h1>
                    : category === "Animal Health" ? <h1>Shop animal health products <br /> at a low cost</h1>
                    : category === "Medical Supplies" ? <h1>Shop medical/surgical products <br /> at a low cost</h1>
                    : <h1> </h1>
                    } */}
                    <ShopCategories
                        brand={brand}
                        className="shop-categories container-fluid d-flex">
                        {
                            auth && <button id="favorites-btn"
                                className={"category-button" + (category === "Favorites" ? " active" : "")}
                                onClick={() => setCategoryPreservePage("Favorites")}>
                                My Favorites
                            </button>
                        }
                        <button id="deals-btn" className={"category-button" + (category === "Specials" ? " active" : "")} onClick={() => setCategoryPreservePage("Specials")}>
                            Short Dated
                        </button>
                        <button id="pharmacy-btn" className={"category-button" + (category === "Pharmaceuticals" ? " active" : "")} onClick={() => setCategoryPreservePage("Pharmaceuticals")}>
                            Pharmaceuticals
                        </button>
                        <button id="animal-btn" className={"category-button" + (category === "Animal Health" ? " active" : "")} onClick={() => setCategoryPreservePage("Animal Health")}>
                            Animal Health
                        </button>
                        <button id="medical-btn" className={"category-button" + (category === "Medical Supplies" ? " active" : "")} onClick={() => setCategoryPreservePage("Medical Supplies")}>
                            Medical/Surgical
                        </button>
                        {/* {brand && brand.name === "premierpharma" &&<button id="smoking-cessation-btn" className={"category-button" + (category === "Smoking Cessation" ? " active" : "")} onClick={() => setCategory("Smoking Cessation")}>
                            Smoking Cessation 
                        </button>} */}
                        {brand && brand.name === "premierpharma" &&<button id="premier-choice-btn" className={"category-button" + (category === "Premier's Choice" ? " active" : "")} onClick={() => setCategoryPreservePage("Premier's Choice")}>
                        Premier's Choice 
                        </button>}
                    </ShopCategories>
                </div>

                <div className="container-fluid px-4">
                    <div className="content">
                        <NotificationBanner brand={brand} />
                        <Productsv2
                            brand={brand}
                            page="shop"
                            shopFont={true}
                            view={view}
                            setView={setView}
                            category={category}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                        />
                    </div>
                </div>
            </StyledShopPage>
            <Footer />
        </>
    );
};

export default ShopV2;
